module.exports = __webpack_public_path__ + "static/img/1_2.0d7b5619.jpg";